<template>
  <div
    class="bg-white h-full rounded-2xl p-8 flex flex-col border-2 border-[#3DAB81] border-opacity-30"
  >
    <div class="mb-6">
      <component
        :is="icon"
        class="w-8 h-8 text-emerald-500"
        aria-hidden="true"
      />
    </div>

    <h3
      class="text-2xl sm:text-3xl font-heading font-semibold text-gray-900 mb-4"
    >
      {{ title }}
    </h3>

    <div class="text-base text-gray-600 mb-6">
      {{ timeline }}
    </div>

    <ul class="space-y-3 flex-grow">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-3 text-gray-700"
      >
        <svg
          class="w-5 h-5 text-emerald-500 flex-shrink-0 mt-1"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="text-base leading-relaxed">{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  icon: {
    type: [Object, Function],
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  timeline: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
});
</script>
